import { useTranslation } from 'react-i18next'

import { Add } from '@mui/icons-material'
import { Box, Button, Chip, Fab, Grid, Tooltip } from '@mui/material'

import { useField, useFormikContext } from 'formik'

import { IModificationRow } from 'types'

import SelectField from 'components/atoms/fields/SelectField'
import { useGET_schoolSetupModificationsSelectQuery, useGET_modificationCategoriesSelectQuery } from 'redux/api/setupApi'
import { FaTrashAlt } from 'react-icons/fa'
import { cloneDeep } from 'lodash'
import { useState } from 'react'

const ModificationList = ({ fieldProps }) => {
  const { t } = useTranslation()
  const [field] = useField<IModificationRow[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state

  const [clickStep, setClickStep] = useState(1)

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        category: null,
        items: [],
      },
    ])
  }

  const handleRemoveEntity = (index) => {
    const entities = cloneDeep(field.value)
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }



  return (
    <>
      {field?.value?.length > 0 ? (
          field?.value.map((value: IModificationRow, index: number) => (

                    <Grid container spacing={2} sx={{ paddingBottom: '10px !important' }} key={`modification_${index}`}>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                fieldProps={{
                                    label: t('common.modification'),
                                    name: `${fieldProps.name}[${index}]['category']`
                                }}
                                filters={{ is_enabled: true }}
                                apiCall={useGET_modificationCategoriesSelectQuery}
                                hasHint={true}
                            />
                        </Grid>
                        { value.category &&  <Grid item xs={12} md={5}>
                            <SelectField
                              fieldProps={{
                                label: t('common.modification-items'),
                                name: `${fieldProps.name}[${index}]['items']`
                              }}
                              multiple={true}
                              filters={{ page_size: 9999, categories: [value.category.id], clickStep: clickStep }}
                              apiCall={useGET_schoolSetupModificationsSelectQuery}
                              hasHint={true}
                            />
                        </Grid>
                        }
                        <Grid item xs={12} md={1}>
                            <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                                <Button
                                onClick={() => { 
                                    handleRemoveEntity(index) 
                                } }
                                aria-label='delete'
                                size='small'
                                color='error'
                                variant='outlined'
                                sx={{
                                    margin: '0',
                                    marginLeft: '10px',
                                    boxShadow: 'none',
                                    padding: '0.5rem 0.1rem',
                                    minWidth: '2.5rem !important',
                                    maxWidth: '2.5rem !important',
                                }}
                                >
                                <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>    
          ))
        ) : (
          <></>
        )}

       
          <Tooltip title={`${t('common.add')}`} arrow placement='top'>
            <Fab
              variant='extended'
              aria-label='add'
              size='small'
              onClick={handleAddEntity}
              color='success'
              sx={{ margin: '1rem 0 0.5rem auto', boxShadow: 'none' }}
            >
              <Add style={{ fontSize: '1.8rem' }} /> {t('common.add-modification')}
            </Fab>
          </Tooltip>
    </>
  )
}

export default ModificationList
